export default {
    url: '/templates',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/tasklist/templates/index.js